(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zunftlexikon-hoerbuch-natural"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-zb-audiobook-root]');
  if (!root || root.dataset.zbNaturalVoiceReady === 'true') return;
  root.dataset.zbNaturalVoiceReady = 'true';

  const synth = window.speechSynthesis;
  if (!synth || typeof window.SpeechSynthesisUtterance !== 'function') return;

  const playButton = root.querySelector('[data-zb-play]');
  const prevButton = root.querySelector('[data-zb-prev]');
  const nextButton = root.querySelector('[data-zb-next]');
  const restartButton = root.querySelector('[data-zb-restart]');
  const speedSelect = root.querySelector('[data-zb-speed]');
  const voiceSelect = root.querySelector('[data-zb-voice]');
  const counter = root.querySelector('[data-zb-counter]');
  const currentTitle = root.querySelector('[data-zb-current-title]');
  const progress = root.querySelector('[data-zb-progress]');
  const status = root.querySelector('[data-zb-status]');
  const chapterElements = Array.from(root.querySelectorAll('[data-zb-chapter]'));
  if (!playButton || !speedSelect || !voiceSelect || !chapterElements.length) return;

  const chapters = chapterElements.map((element) => ({
    element,
    title: element.dataset.title || '',
    text: (element.querySelector('[data-zb-chapter-text]')?.textContent || '').trim()
  }));

  const VOICE_KEY = 'zb-audiobook-voice-v2';
  let voices = [];
  let selectedVoice = null;
  let currentIndex = 0;
  let queue = [];
  let queueIndex = 0;
  let token = 0;
  let timer = 0;
  let playing = false;
  let paused = false;
  let continueBook = true;
  let activeUtterance = null;

  const normalize = (value) => String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const voiceScore = (voice) => {
    const name = normalize(`${voice.name} ${voice.voiceURI}`);
    let score = 0;
    if (name.includes('google deutsch')) score += 1000;
    else if (name.includes('google')) score += 500;
    if (normalize(voice.lang) === 'de-de') score += 20;
    if (voice.default) score += 5;
    return score;
  };

  const updateUi = () => {
    const chapter = chapters[currentIndex];
    if (!chapter) return;
    if (counter) counter.textContent = `Kapitel ${currentIndex + 1} von ${chapters.length}`;
    if (currentTitle) currentTitle.textContent = chapter.title;
    if (progress) progress.style.width = `${((currentIndex + 1) / chapters.length) * 100}%`;
    chapters.forEach((item, index) => { item.element.dataset.active = index === currentIndex ? 'true' : 'false'; });
    if (paused) {
      playButton.textContent = '▶ Weiter';
      playButton.setAttribute('aria-label', 'Hörbuch fortsetzen');
    } else if (playing) {
      playButton.textContent = '❚❚ Pause';
      playButton.setAttribute('aria-label', 'Hörbuch pausieren');
    } else {
      playButton.textContent = '▶ Hörbuch starten';
      playButton.setAttribute('aria-label', 'Hörbuch starten');
    }
  };

  const loadVoices = () => {
    voices = synth.getVoices().filter((voice) => /^de(?:[-_]|$)/i.test(voice.lang));
    if (!voices.length) return;

    const oldValue = voiceSelect.value;
    voiceSelect.innerHTML = '';
    voices.slice().sort((a, b) => voiceScore(b) - voiceScore(a) || a.name.localeCompare(b.name, 'de')).forEach((voice) => {
      const option = document.createElement('option');
      option.value = voice.name;
      option.textContent = `${voice.name} (${voice.lang})`;
      voiceSelect.appendChild(option);
    });

    let stored = null;
    try { stored = localStorage.getItem(VOICE_KEY); } catch (error) { /* no-op */ }
    selectedVoice = voices.find((voice) => stored && voice.name === stored)
      || voices.slice().sort((a, b) => voiceScore(b) - voiceScore(a))[0]
      || voices.find((voice) => voice.name === oldValue)
      || voices[0];

    voiceSelect.value = selectedVoice.name;
    const googleDeutsch = normalize(`${selectedVoice.name} ${selectedVoice.voiceURI}`).includes('google deutsch');
    if (status) status.textContent = googleDeutsch
      ? `Erzählerstimme: ${selectedVoice.name}. Kurze Sprechphrasen und natürliche Pausen sind aktiv.`
      : `Erzählerstimme: ${selectedVoice.name}. Google Deutsch wird bevorzugt, sobald der Browser sie anbietet.`;
  };

  const splitLongPhrase = (phrase, maxLength = 210) => {
    const clean = phrase.trim();
    if (!clean) return [];
    if (clean.length <= maxLength) return [clean];
    const parts = clean.split(/(?<=[,;:])\s+/);
    const out = [];
    let buffer = '';
    parts.forEach((part) => {
      const candidate = buffer ? `${buffer} ${part}` : part;
      if (candidate.length <= maxLength) {
        buffer = candidate;
      } else {
        if (buffer) out.push(buffer.trim());
        buffer = part;
      }
    });
    if (buffer) out.push(buffer.trim());
    return out;
  };

  const buildQueue = (chapter) => {
    const sentences = chapter.text.match(/[^.!?…]+(?:[.!?…]+|$)/g) || [chapter.text];
    const result = [{ text: chapter.title, pause: 320 }];
    sentences.forEach((sentence) => {
      const parts = splitLongPhrase(sentence);
      parts.forEach((part, index) => result.push({
        text: part,
        pause: index === parts.length - 1 ? 190 : 105
      }));
    });
    return result.filter((item) => item.text);
  };

  const clearTimer = () => {
    if (timer) window.clearTimeout(timer);
    timer = 0;
  };

  const stop = (message = '') => {
    token += 1;
    clearTimer();
    activeUtterance = null;
    queue = [];
    queueIndex = 0;
    playing = false;
    paused = false;
    synth.cancel();
    if (message && status) status.textContent = message;
    updateUi();
  };

  const finishChapter = (myToken) => {
    if (myToken !== token) return;
    activeUtterance = null;
    queue = [];
    queueIndex = 0;
    if (continueBook && currentIndex < chapters.length - 1) {
      currentIndex += 1;
      updateUi();
      timer = window.setTimeout(() => startChapter(currentIndex, true), 420);
      return;
    }
    playing = false;
    paused = false;
    if (status) status.textContent = continueBook && currentIndex === chapters.length - 1
      ? 'Hörbuch beendet.'
      : `Kapitel ${currentIndex + 1} beendet.`;
    updateUi();
  };

  const speakQueueItem = (myToken) => {
    if (myToken !== token || !playing || paused) return;
    const item = queue[queueIndex];
    if (!item) {
      finishChapter(myToken);
      return;
    }

    const utterance = new SpeechSynthesisUtterance(item.text);
    utterance.lang = 'de-DE';
    utterance.rate = (Number(speedSelect.value) || 1) * 0.96;
    utterance.pitch = 1;
    if (selectedVoice) utterance.voice = selectedVoice;
    activeUtterance = utterance;

    utterance.onend = () => {
      if (myToken !== token || activeUtterance !== utterance) return;
      activeUtterance = null;
      queueIndex += 1;
      if (queueIndex >= queue.length) {
        finishChapter(myToken);
        return;
      }
      timer = window.setTimeout(() => speakQueueItem(myToken), item.pause || 150);
    };
    utterance.onerror = (event) => {
      if (event.error === 'canceled' || event.error === 'interrupted') return;
      stop('Die Sprachausgabe konnte diesen Abschnitt nicht wiedergeben.');
    };
    synth.speak(utterance);
  };

  const startChapter = (index, playFollowing) => {
    if (!chapters[index]) return;
    token += 1;
    const myToken = token;
    clearTimer();
    synth.cancel();
    currentIndex = index;
    continueBook = playFollowing;
    queue = buildQueue(chapters[index]);
    queueIndex = 0;
    activeUtterance = null;
    playing = true;
    paused = false;
    if (status) status.textContent = `Es läuft: Kapitel ${currentIndex + 1} – ${chapters[index].title}`;
    updateUi();
    timer = window.setTimeout(() => speakQueueItem(myToken), 70);
  };

  const pause = () => {
    if (!playing || paused) return;
    paused = true;
    clearTimer();
    if (synth.speaking) synth.pause();
    if (status) status.textContent = `Pausiert: Kapitel ${currentIndex + 1} – ${chapters[currentIndex].title}`;
    updateUi();
  };

  const resume = () => {
    if (!playing || !paused) return;
    paused = false;
    if (status) status.textContent = `Es läuft: Kapitel ${currentIndex + 1} – ${chapters[currentIndex].title}`;
    if (synth.paused) synth.resume();
    else timer = window.setTimeout(() => speakQueueItem(token), 80);
    updateUi();
  };

  root.addEventListener('click', (event) => {
    const target = event.target.closest('button');
    if (!target || !root.contains(target)) return;

    if (target.matches('[data-zb-play]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (playing && paused) resume();
      else if (playing) pause();
      else startChapter(currentIndex, true);
      return;
    }
    if (target.matches('[data-zb-prev]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      stop(); currentIndex = Math.max(0, currentIndex - 1); updateUi();
      return;
    }
    if (target.matches('[data-zb-next]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      stop(); currentIndex = Math.min(chapters.length - 1, currentIndex + 1); updateUi();
      return;
    }
    if (target.matches('[data-zb-restart]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      stop(); currentIndex = 0; updateUi(); startChapter(0, true);
      return;
    }
    if (target.matches('[data-zb-play-chapter]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      const index = chapterElements.findIndex((element) => element.contains(target));
      if (index >= 0) startChapter(index, false);
    }
  }, true);

  root.addEventListener('change', (event) => {
    if (event.target === voiceSelect) {
      event.stopImmediatePropagation();
      selectedVoice = voices.find((voice) => voice.name === voiceSelect.value) || null;
      if (selectedVoice) {
        try { localStorage.setItem(VOICE_KEY, selectedVoice.name); } catch (error) { /* no-op */ }
        if (status) status.textContent = `Erzählerstimme: ${selectedVoice.name}.`;
      }
      if (playing) startChapter(currentIndex, continueBook);
    }
    if (event.target === speedSelect) {
      event.stopImmediatePropagation();
      if (playing) startChapter(currentIndex, continueBook);
    }
  }, true);

  loadVoices();
  if ('onvoiceschanged' in synth) synth.addEventListener('voiceschanged', loadVoices);
  window.addEventListener('pagehide', () => { clearTimer(); synth.cancel(); }, { once: true });
  updateUi();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zunftlexikon-hoerbuch"] && !Shopify.designMode) return;
  try {
    (() => {
  const roots = document.querySelectorAll('[data-zb-audiobook-root]');
  if (!roots.length) return;

  roots.forEach((root) => {
    if (root.dataset.zbReady === 'true') return;
    root.dataset.zbReady = 'true';

    const main = document.querySelector('main');
    const heading = main ? main.querySelector('h1') : document.querySelector('h1');
    if (heading && heading.parentNode && heading.nextElementSibling !== root) {
      heading.insertAdjacentElement('afterend', root);
    }

    const chapters = Array.from(root.querySelectorAll('[data-zb-chapter]')).map((element) => ({
      element,
      title: element.dataset.title || '',
      text: (element.querySelector('[data-zb-chapter-text]')?.textContent || '').trim()
    }));

    const playButton = root.querySelector('[data-zb-play]');
    const prevButton = root.querySelector('[data-zb-prev]');
    const nextButton = root.querySelector('[data-zb-next]');
    const restartButton = root.querySelector('[data-zb-restart]');
    const speedSelect = root.querySelector('[data-zb-speed]');
    const voiceSelect = root.querySelector('[data-zb-voice]');
    const counter = root.querySelector('[data-zb-counter]');
    const currentTitle = root.querySelector('[data-zb-current-title]');
    const progress = root.querySelector('[data-zb-progress]');
    const status = root.querySelector('[data-zb-status]');

    let currentIndex = 0;
    let activeUtterance = null;
    let continueThroughBook = true;
    let voices = [];
    let selectedVoice = null;
    const synth = window.speechSynthesis;

    const updateUi = () => {
      const chapter = chapters[currentIndex];
      if (!chapter) return;
      counter.textContent = `Kapitel ${currentIndex + 1} von ${chapters.length}`;
      currentTitle.textContent = chapter.title;
      progress.style.width = `${((currentIndex + 1) / chapters.length) * 100}%`;
      chapters.forEach((item, index) => { item.element.dataset.active = index === currentIndex ? 'true' : 'false'; });

      if (!synth) {
        playButton.textContent = 'Vorlesen nicht verfügbar';
        playButton.disabled = true;
        status.textContent = 'Dieser Browser unterstützt die integrierte Sprachausgabe nicht. Der vollständige Hörtext bleibt unter „Hörtext prüfen“ verfügbar.';
        return;
      }
      if (synth.speaking && !synth.paused) {
        playButton.textContent = '❚❚ Pause';
        playButton.setAttribute('aria-label', 'Hörbuch pausieren');
      } else if (synth.paused) {
        playButton.textContent = '▶ Weiter';
        playButton.setAttribute('aria-label', 'Hörbuch fortsetzen');
      } else {
        playButton.textContent = '▶ Hörbuch starten';
        playButton.setAttribute('aria-label', 'Hörbuch starten');
      }
    };

    const preferredMaleNames = /markus|martin|stefan|thomas|daniel|hans|karl|georg|ralf|florian|conrad|yannick|male|männ/i;

    const loadVoices = () => {
      if (!synth) return;
      voices = synth.getVoices().filter((voice) => /^de([-_]|$)/i.test(voice.lang));
      if (!voices.length) {
        voiceSelect.innerHTML = '<option value="">Deutsche Systemstimme</option>';
        selectedVoice = null;
        status.textContent = 'Keine ausdrücklich deutsch markierte Stimme gefunden. Der Browser verwendet seine Standardstimme.';
        return;
      }
      voiceSelect.innerHTML = '';
      voices.forEach((voice) => {
        const option = document.createElement('option');
        option.value = voice.name;
        option.textContent = `${voice.name} (${voice.lang})`;
        voiceSelect.appendChild(option);
      });
      const stored = window.localStorage ? localStorage.getItem('zb-audiobook-voice') : null;
      selectedVoice = voices.find((voice) => stored && voice.name === stored) || voices.find((voice) => preferredMaleNames.test(voice.name)) || voices[0];
      voiceSelect.value = selectedVoice.name;
      status.textContent = `Erzählerstimme: ${selectedVoice.name}. Für den Pilot wird eine verfügbare deutsche Systemstimme verwendet.`;
    };

    const clearSpeech = () => {
      activeUtterance = null;
      continueThroughBook = false;
      if (synth) synth.cancel();
      updateUi();
    };

    const speakChapter = (index, playFollowingChapters) => {
      if (!synth || !chapters[index]) return;
      activeUtterance = null;
      synth.cancel();
      currentIndex = index;
      continueThroughBook = playFollowingChapters;
      const chapter = chapters[index];
      const utterance = new SpeechSynthesisUtterance(`${chapter.title}. ${chapter.text}`);
      utterance.lang = 'de-DE';
      utterance.rate = Number(speedSelect.value) || 1;
      utterance.pitch = 0.95;
      if (selectedVoice) utterance.voice = selectedVoice;
      activeUtterance = utterance;

      utterance.onstart = () => {
        if (activeUtterance !== utterance) return;
        status.textContent = `Es läuft: Kapitel ${currentIndex + 1} – ${chapter.title}`;
        updateUi();
      };
      utterance.onpause = updateUi;
      utterance.onresume = updateUi;
      utterance.onerror = (event) => {
        if (activeUtterance !== utterance) return;
        activeUtterance = null;
        status.textContent = event.error === 'canceled' ? 'Wiedergabe beendet.' : 'Die Sprachausgabe konnte dieses Kapitel nicht starten.';
        updateUi();
      };
      utterance.onend = () => {
        if (activeUtterance !== utterance) return;
        activeUtterance = null;
        if (continueThroughBook && currentIndex < chapters.length - 1) {
          currentIndex += 1;
          updateUi();
          window.setTimeout(() => speakChapter(currentIndex, true), 160);
          return;
        }
        status.textContent = currentIndex === chapters.length - 1 && continueThroughBook ? 'Hörbuch beendet.' : `Kapitel ${currentIndex + 1} beendet.`;
        updateUi();
      };
      updateUi();
      synth.speak(utterance);
    };

    playButton.addEventListener('click', () => {
      if (!synth) return;
      if (synth.speaking && synth.paused) { synth.resume(); updateUi(); return; }
      if (synth.speaking) { synth.pause(); updateUi(); return; }
      speakChapter(currentIndex, true);
    });

    prevButton.addEventListener('click', () => {
      const shouldContinue = Boolean(synth && synth.speaking);
      clearSpeech();
      currentIndex = Math.max(0, currentIndex - 1);
      updateUi();
      if (shouldContinue) speakChapter(currentIndex, true);
    });
    nextButton.addEventListener('click', () => {
      const shouldContinue = Boolean(synth && synth.speaking);
      clearSpeech();
      currentIndex = Math.min(chapters.length - 1, currentIndex + 1);
      updateUi();
      if (shouldContinue) speakChapter(currentIndex, true);
    });
    restartButton.addEventListener('click', () => {
      clearSpeech();
      currentIndex = 0;
      updateUi();
      speakChapter(0, true);
    });

    root.querySelectorAll('[data-zb-play-chapter]').forEach((button, index) => {
      button.addEventListener('click', () => speakChapter(index, false));
    });

    speedSelect.addEventListener('change', () => {
      if (synth && synth.speaking) speakChapter(currentIndex, continueThroughBook);
    });
    voiceSelect.addEventListener('change', () => {
      selectedVoice = voices.find((voice) => voice.name === voiceSelect.value) || null;
      if (selectedVoice && window.localStorage) localStorage.setItem('zb-audiobook-voice', selectedVoice.name);
      status.textContent = selectedVoice ? `Erzählerstimme: ${selectedVoice.name}.` : 'Deutsche Systemstimme.';
      if (synth && synth.speaking) speakChapter(currentIndex, continueThroughBook);
    });

    if (synth) {
      loadVoices();
      if ('onvoiceschanged' in synth) synth.addEventListener('voiceschanged', loadVoices);
    }
    window.addEventListener('pagehide', () => { if (synth) synth.cancel(); }, { once: true });
    updateUi();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zunftmeister-animated-shell"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__zbZunftmeisterReal3DV2) return;
  window.__zbZunftmeisterReal3DV2 = true;

  const SEEN_KEY = 'zb-zunftmeister-real3d-seen-v2';
  const STATE_KEY = 'zb-zunftmeister-real3d-state-v2';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const sleep = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

  const safeGet = (key) => {
    try { return sessionStorage.getItem(key); } catch (error) { return null; }
  };

  const safeSet = (key, value) => {
    try { sessionStorage.setItem(key, value); } catch (error) {}
  };

  const init = () => {
    const root = document.querySelector('[data-zb-zm]');
    const stage = document.querySelector('[data-zb-zm-stage]');
    const miniTemplate = document.querySelector('[data-zb-zm-mini-template]');
    if (!root || !stage || !miniTemplate) return;

    const panel = root.querySelector('[data-zb-zm-panel]');
    const input = root.querySelector('[data-zb-zm-input]');
    const originalToggle = root.querySelector('[data-zb-zm-toggle]');
    const visual = stage.querySelector('[data-zb-zm-visual]');
    const particles = stage.querySelector('[data-zb-zm-particles]');
    if (!panel || !input || !originalToggle || !visual) return;

    originalToggle.hidden = true;

    const title = root.querySelector('.zb-zm__title');
    const eyebrow = root.querySelector('.zb-zm__eyebrow');
    const greeting = root.querySelector('[data-zb-zm-log] .zb-zm__message--bot');
    const prototype = root.querySelector('.zb-zm__prototype');

    if (title) title.textContent = 'Zunftmeister';
    if (eyebrow) eyebrow.textContent = 'Ihr Assistent · Zunftbild.de';
    if (greeting) greeting.textContent = 'Grüß dich! Wie kann ich dir weiterhelfen? Frag mich zu Zünften, Handwerk, Berufen, Städten, Traditionen und Zunftbild.de.';
    if (prototype) prototype.textContent = 'Zunftmeister · Antworten aus der Zunftbild-Wissensbasis.';

    const headerCopy = root.querySelector('.zb-zm__header > div:first-child');
    if (headerCopy && !headerCopy.querySelector('.zb-zm__header-mini')) {
      const avatar = document.createElement('span');
      avatar.className = 'zb-zm__header-mini';
      avatar.append(miniTemplate.content.cloneNode(true));
      headerCopy.prepend(avatar);
    }

    const headerIcons = document.querySelector('.header__icons');
    const cart = headerIcons?.querySelector('#cart-icon-bubble');
    const menuButton = document.createElement('button');
    menuButton.type = 'button';
    menuButton.className = 'zb-zm-header-avatar';
    menuButton.setAttribute('aria-label', 'Zunftmeister öffnen');
    menuButton.setAttribute('title', 'Zunftmeister öffnen');
    menuButton.hidden = true;
    menuButton.append(miniTemplate.content.cloneNode(true));

    if (headerIcons) {
      if (cart) headerIcons.insertBefore(menuButton, cart);
      else headerIcons.append(menuButton);
    } else {
      menuButton.style.position = 'fixed';
      menuButton.style.top = '12px';
      menuButton.style.right = '12px';
      menuButton.style.zIndex = '2147482200';
      document.body.append(menuButton);
    }

    const frameUrls = {
      walk: stage.dataset.walk,
      walkWave: stage.dataset.walkWave,
      wave: stage.dataset.wave,
      dissolve: stage.dataset.dissolve
    };

    const frames = {};
    let framePromise = null;

    const preloadFrames = () => {
      if (framePromise) return framePromise;
      framePromise = Promise.all(Object.entries(frameUrls).map(([name, src]) => new Promise((resolve) => {
        const img = new Image();
        img.className = `zb-zm-real-frame zb-zm-real-frame--${name}`;
        img.alt = '';
        img.decoding = 'async';
        img.draggable = false;
        img.onload = () => resolve();
        img.onerror = () => resolve();
        img.src = src;
        frames[name] = img;
        visual.append(img);
      })));
      return framePromise;
    };

    const showFrame = (name) => {
      Object.entries(frames).forEach(([key, img]) => img.classList.toggle('is-active', key === name));
    };

    let sequenceRunning = false;
    let storeRunning = false;

    const resetStage = () => {
      stage.hidden = true;
      stage.classList.remove('is-entering', 'is-waving', 'is-dissolving');
      if (particles) particles.textContent = '';
      Object.values(frames).forEach((img) => img.classList.remove('is-active'));
    };

    const buildParticles = () => {
      if (!particles) return;
      particles.textContent = '';
      for (let i = 0; i < 74; i += 1) {
        const dot = document.createElement('span');
        const angle = (-2.75 + Math.random() * 5.2);
        const distance = 72 + Math.random() * 210;
        const x = Math.cos(angle) * distance + 28 + Math.random() * 80;
        const y = Math.sin(angle) * distance - 12 - Math.random() * 92;
        dot.className = `zb-zm-particle${i % 9 === 0 ? ' is-star' : ''}`;
        dot.style.setProperty('--x', `${x.toFixed(1)}px`);
        dot.style.setProperty('--y', `${y.toFixed(1)}px`);
        dot.style.setProperty('--d', `${Math.round(Math.random() * 210)}ms`);
        dot.style.setProperty('--s', `${(3 + Math.random() * 7).toFixed(1)}px`);
        dot.style.setProperty('--l', `${(35 + Math.random() * 48).toFixed(1)}%`);
        dot.style.setProperty('--t', `${(14 + Math.random() * 77).toFixed(1)}%`);
        dot.style.setProperty('--c', i % 4 === 0 ? '#fff0b0' : i % 3 === 0 ? '#ffc95c' : '#dc9f38');
        particles.append(dot);
      }
    };

    const sparklePath = (from, to) => {
      const count = 17;
      for (let i = 0; i < count; i += 1) {
        const p = document.createElement('span');
        const progress = i / (count - 1);
        const x = from.x + (to.x - from.x) * progress;
        const y = from.y + (to.y - from.y) * progress - Math.sin(progress * Math.PI) * 34;
        p.className = 'zb-zm-fly-spark';
        p.style.left = `${x}px`;
        p.style.top = `${y}px`;
        p.style.setProperty('--s', `${3 + (i % 4)}px`);
        p.style.setProperty('--d', `${i * 15}ms`);
        p.style.setProperty('--jx', `${-11 + Math.random() * 22}px`);
        p.style.setProperty('--jy', `${-13 + Math.random() * 26}px`);
        document.body.append(p);
        window.setTimeout(() => p.remove(), 950);
      }
    };

    const openPanel = async (focusInput = true) => {
      panel.hidden = false;
      originalToggle.setAttribute('aria-expanded', 'true');
      safeSet(STATE_KEY, 'open');
      if (!reducedMotion.matches && panel.animate) {
        panel.animate([
          { opacity: 0, transform: 'translateY(20px) scale(.95)', filter: 'blur(3px)' },
          { opacity: 1, transform: 'translateY(0) scale(1)', filter: 'blur(0)' }
        ], { duration: 330, easing: 'cubic-bezier(.18,.82,.2,1)' });
      }
      if (focusInput) window.setTimeout(() => input.focus(), 110);
    };

    const runIntro = async ({ focusInput = true } = {}) => {
      if (sequenceRunning || storeRunning) return;
      sequenceRunning = true;
      menuButton.hidden = true;
      panel.hidden = true;
      originalToggle.setAttribute('aria-expanded', 'false');
      safeSet(SEEN_KEY, '1');
      safeSet(STATE_KEY, 'opening');

      await preloadFrames();

      if (reducedMotion.matches) {
        resetStage();
        await openPanel(focusInput);
        sequenceRunning = false;
        return;
      }

      resetStage();
      showFrame('walk');
      stage.hidden = false;
      void stage.offsetWidth;
      stage.classList.add('is-entering');

      await sleep(680);
      showFrame('walkWave');
      await sleep(520);
      showFrame('walk');
      await sleep(470);

      stage.classList.remove('is-entering');
      stage.classList.add('is-waving');
      showFrame('wave');

      await sleep(330);
      showFrame('walkWave');
      await sleep(180);
      showFrame('wave');
      await sleep(330);
      showFrame('walkWave');
      await sleep(170);
      showFrame('wave');
      await sleep(420);

      stage.classList.remove('is-waving');
      showFrame('dissolve');
      buildParticles();
      stage.classList.add('is-dissolving');
      await sleep(1130);

      resetStage();
      await openPanel(focusInput);
      sequenceRunning = false;
    };

    const storeInHeader = async () => {
      if (storeRunning || sequenceRunning || panel.hidden) return;
      storeRunning = true;
      safeSet(STATE_KEY, 'stored');

      if (reducedMotion.matches || !panel.animate) {
        panel.hidden = true;
        originalToggle.setAttribute('aria-expanded', 'false');
        menuButton.hidden = false;
        menuButton.classList.remove('is-stored');
        void menuButton.offsetWidth;
        menuButton.classList.add('is-stored');
        storeRunning = false;
        menuButton.focus();
        return;
      }

      const fromRect = panel.getBoundingClientRect();
      menuButton.hidden = false;
      menuButton.style.opacity = '0';
      const toRect = menuButton.getBoundingClientRect();
      menuButton.hidden = true;
      menuButton.style.opacity = '';

      const from = { x: fromRect.left + fromRect.width * .82, y: fromRect.top + fromRect.height * .22 };
      const to = { x: toRect.left + toRect.width / 2, y: toRect.top + toRect.height / 2 };
      sparklePath(from, to);

      const dx = to.x - (fromRect.left + fromRect.width / 2);
      const dy = to.y - (fromRect.top + fromRect.height / 2);
      panel.classList.add('zb-zm-panel-storing');

      const animation = panel.animate([
        { opacity: 1, transform: 'translate(0,0) scale(1)', filter: 'blur(0)' },
        { opacity: .78, offset: .45, transform: `translate(${dx * .46}px,${dy * .46}px) scale(.58)`, filter: 'blur(.5px)' },
        { opacity: .28, offset: .78, transform: `translate(${dx * .82}px,${dy * .82}px) scale(.22)`, filter: 'blur(1.6px)' },
        { opacity: 0, transform: `translate(${dx}px,${dy}px) scale(.05)`, filter: 'blur(4px)' }
      ], { duration: 760, easing: 'cubic-bezier(.24,.74,.2,1)' });

      try { await animation.finished; } catch (error) {}

      panel.hidden = true;
      panel.classList.remove('zb-zm-panel-storing');
      originalToggle.setAttribute('aria-expanded', 'false');
      menuButton.hidden = false;
      menuButton.classList.remove('is-stored');
      void menuButton.offsetWidth;
      menuButton.classList.add('is-stored');
      storeRunning = false;
      menuButton.focus();
    };

    menuButton.addEventListener('click', () => runIntro({ focusInput: true }));

    document.addEventListener('click', (event) => {
      const close = event.target?.closest?.('[data-zb-zm-close]');
      if (!close || !root.contains(close)) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      storeInHeader();
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || panel.hidden) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      storeInHeader();
    }, true);

    const seen = safeGet(SEEN_KEY) === '1';
    const state = safeGet(STATE_KEY);

    if (window.Shopify?.designMode) {
      panel.hidden = true;
      menuButton.hidden = false;
      safeSet(STATE_KEY, 'stored');
      return;
    }

    if (!seen) {
      window.setTimeout(() => runIntro({ focusInput: false }), 650);
    } else if (state === 'open') {
      panel.hidden = false;
      menuButton.hidden = true;
      originalToggle.setAttribute('aria-expanded', 'true');
    } else {
      panel.hidden = true;
      menuButton.hidden = false;
      originalToggle.setAttribute('aria-expanded', 'false');
      safeSet(STATE_KEY, 'stored');
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zunftmeister-gateway-layer"] && !Shopify.designMode) return;
  try {
    (() => {
  const CHAT_ENDPOINT = 'https://zunftbild-ai-gateway.vercel.app/api/chat';
  const states = new WeakMap();

  const stateFor = (root) => {
    if (!states.has(root)) states.set(root, { history: [], serial: 0, controller: null });
    return states.get(root);
  };

  const setStatus = (root, value, busy = false) => {
    const el = root.querySelector('.zb-zm__status');
    if (!el) return;
    const dot = el.querySelector('span');
    Array.from(el.childNodes).forEach((node) => { if (node !== dot) node.remove(); });
    el.append(document.createTextNode(` ${value}`));
    el.dataset.busy = busy ? 'true' : 'false';
  };

  const appendPlainMessage = (root, role, value) => {
    const log = root.querySelector('[data-zb-zm-log]');
    if (!log) return;
    const el = document.createElement('div');
    el.className = `zb-zm__message zb-zm__message--${role}`;
    el.textContent = String(value || '');
    log.append(el);
    log.scrollTop = log.scrollHeight;
  };

  const appendSafeFormattedText = (parent, value) => {
    const lines = String(value || '').replace(/\r/g, '').split('\n');
    lines.forEach((line, lineIndex) => {
      const parts = line.split(/(\*\*[^*]+\*\*)/g).filter(Boolean);
      parts.forEach((part) => {
        if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
          const strong = document.createElement('strong');
          strong.textContent = part.slice(2, -2);
          parent.append(strong);
        } else {
          parent.append(document.createTextNode(part));
        }
      });
      if (lineIndex < lines.length - 1) parent.append(document.createElement('br'));
    });
  };

  const trustedSourceUrl = (href) => {
    try {
      const source = new URL(href, 'https://zunftbild.de');
      if (!['zunftbild.de', 'www.zunftbild.de'].includes(source.hostname)) return '';
      const local = new URL(source.pathname + source.search + source.hash, window.location.origin);
      const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewId) local.searchParams.set('preview_theme_id', previewId);
      return local.pathname + local.search + local.hash;
    } catch (error) {
      return '';
    }
  };

  const renderAnswer = (root, answer, sources) => {
    const log = root.querySelector('[data-zb-zm-log]');
    if (!log) return;

    const wrap = document.createElement('div');
    wrap.className = 'zb-zm__message zb-zm__message--bot zb-zm__message--gateway';

    const p = document.createElement('p');
    p.className = 'zb-zm__gateway-answer';
    appendSafeFormattedText(p, answer);
    wrap.append(p);

    const safeSources = (Array.isArray(sources) ? sources : []).map((source) => ({
      title: String(source?.title || 'Zunftbild.de'),
      url: trustedSourceUrl(source?.url || '')
    })).filter((source) => source.url).slice(0, 3);

    if (safeSources.length) {
      const list = document.createElement('div');
      list.className = 'zb-zm__source-list';
      safeSources.forEach((source) => {
        const card = document.createElement('div');
        card.className = 'zb-zm__source';
        const meta = document.createElement('span');
        meta.className = 'zb-zm__source-type';
        meta.textContent = 'Quelle';
        const a = document.createElement('a');
        a.className = 'zb-zm__source-link';
        a.href = source.url;
        a.textContent = source.title;
        card.append(meta, a);
        list.append(card);
      });
      wrap.append(list);
    }

    const badge = document.createElement('span');
    badge.className = 'zb-zm__gateway-badge';
    badge.textContent = 'Antwort mit Zunftbild-Wissen';
    wrap.append(badge);

    log.append(wrap);
    log.scrollTop = log.scrollHeight;
  };

  const ask = async (root, question) => {
    const state = stateFor(root);
    state.controller?.abort();
    const controller = new AbortController();
    state.controller = controller;
    const serial = ++state.serial;
    const timer = window.setTimeout(() => controller.abort(), 20000);

    state.history.push({ role: 'user', content: question });
    state.history = state.history.slice(-10);
    setStatus(root, 'Der Zunftmeister schlägt im Zunftlexikon nach …', true);

    try {
      const response = await fetch(CHAT_ENDPOINT, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: state.history }),
        signal: controller.signal
      });

      let payload = {};
      try { payload = await response.json(); } catch (error) {}
      if (controller.signal.aborted || serial !== state.serial) return;
      if (!response.ok || !payload?.ok || !payload?.answer) {
        const technical = String(payload?.error || '');
        if (response.status === 403 && technical.toLowerCase().includes('origin')) {
          throw new Error('preview-origin');
        }
        throw new Error('gateway');
      }

      state.history.push({ role: 'assistant', content: String(payload.answer) });
      state.history = state.history.slice(-10);
      renderAnswer(root, payload.answer, payload.sources);
      setStatus(root, 'Antwort aus dem Zunftbild-Wissen');
    } catch (error) {
      if (serial !== state.serial) return;
      if (controller.signal.aborted) {
        appendPlainMessage(root, 'bot', 'Die Antwort hat gerade zu lange gedauert. Versuch es bitte noch einmal.');
        setStatus(root, 'Bereit für deine Frage');
        return;
      }
      if (error?.message === 'preview-origin') {
        appendPlainMessage(root, 'bot', 'Der Zunftmeister ist in dieser Vorschau noch nicht für die Verbindung freigeschaltet.');
      } else {
        appendPlainMessage(root, 'bot', 'Die Wissensverbindung ist gerade nicht erreichbar. Versuch deine Frage bitte noch einmal.');
      }
      setStatus(root, 'Bereit für deine Frage');
    } finally {
      window.clearTimeout(timer);
    }
  };

  const decorate = () => {
    document.querySelectorAll('[data-zb-zm]').forEach((root) => {
      const note = root.querySelector('.zb-zm__prototype');
      const input = root.querySelector('[data-zb-zm-input]');
      if (note) note.textContent = 'Digitaler Zunftmeister · Antworten mit Zunftbild-Wissen. KI kann sich irren.';
      if (input) input.placeholder = 'Frag den Zunftmeister zu Zünften & Handwerk …';

      const labels = ['Die Walz', 'Meisterstück', 'Dachdecker', 'Zunftzeichen', 'Rückgabe & Versand'];
      root.querySelectorAll('[data-zb-zm-topic]').forEach((button, index) => {
        if (!labels[index]) return;
        button.textContent = labels[index];
        button.dataset.zbAiQuery = labels[index];
      });
      setStatus(root, 'Bereit für deine Frage');
    });
  };

  document.addEventListener('submit', (event) => {
    const form = event.target?.closest?.('[data-zb-zm-form]');
    if (!form) return;
    const root = form.closest('[data-zb-zm]');
    if (!root) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const input = root.querySelector('[data-zb-zm-input]');
    const question = input?.value?.trim();
    if (!question) return;
    appendPlainMessage(root, 'user', question);
    input.value = '';
    ask(root, question);
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target?.closest?.('[data-zb-zm-topic]');
    if (!button) return;
    const root = button.closest('[data-zb-zm]');
    if (!root) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const question = button.dataset.zbAiQuery || button.textContent.trim();
    appendPlainMessage(root, 'user', question);
    ask(root, question);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.setTimeout(decorate, 0), { once: true });
  } else {
    window.setTimeout(decorate, 0);
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zunftmeister-text-only"] && !Shopify.designMode) return;
  try {
    (() => {
  const STOP_WORDS = new Set([
    'aber','alle','alles','als','also','am','an','auch','auf','aus','bei','bin','bis','bist','da','das','dass','dein','deine','dem','den','der','des','die','dies','diese','dieser','doch','du','durch','ein','eine','einer','einem','einen','er','es','etwas','für','fur','gibt','hat','haben','ich','im','in','ist','ja','kann','kannst','man','mehr','mein','mit','nach','nicht','noch','oder','sich','sie','sind','so','über','uber','um','und','uns','von','vor','war','waren','was','welche','welcher','welches','wenn','wer','werden','wie','wir','wo','zu','zum','zur'
  ]);

  const normalize = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

  const stripHtml = (value) => {
    const html = String(value || '');
    if (!html) return '';
    try {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return (doc.body.textContent || '').replace(/\s+/g, ' ').trim();
    } catch (error) {
      return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    }
  };

  const extractKeywords = (question) => {
    const words = String(question || '').match(/[\p{L}\p{N}-]+/gu) || [];
    const unique = [];
    words.forEach((word) => {
      const key = normalize(word);
      if (key.length < 3 || STOP_WORDS.has(key) || unique.some((item) => normalize(item) === key)) return;
      unique.push(word);
    });
    return unique.slice(0, 6);
  };

  const preservePreview = (href) => {
    try {
      const target = new URL(href, window.location.origin);
      if (target.origin !== window.location.origin) return href;
      const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewId) target.searchParams.set('preview_theme_id', previewId);
      return target.pathname + target.search + target.hash;
    } catch (error) {
      return href;
    }
  };

  const typeLabel = (type) => ({
    page: 'Zunftbild-Seite',
    article: 'Artikel',
    product: 'Produkt',
    collection: 'Kollektion'
  }[type] || 'Zunftbild.de');

  const init = () => {
    document.querySelectorAll('[data-zb-zm]').forEach((root) => {
      if (root.dataset.zbTextOnlyReady === 'true') return;
      root.dataset.zbTextOnlyReady = 'true';

      const mic = root.querySelector('[data-zb-zm-mic]');
      const note = root.querySelector('.zb-zm__prototype');
      const input = root.querySelector('[data-zb-zm-input]');
      const form = root.querySelector('[data-zb-zm-form]');
      const log = root.querySelector('[data-zb-zm-log]');
      const firstBot = root.querySelector('.zb-zm__message--bot');
      const status = root.querySelector('.zb-zm__status');
      const topicButtons = Array.from(root.querySelectorAll('[data-zb-zm-topic]'));
      const cache = new Map();
      let activeController = null;
      let requestSerial = 0;

      if (mic) {
        mic.hidden = true;
        mic.disabled = true;
        mic.setAttribute('aria-hidden', 'true');
        mic.setAttribute('tabindex', '-1');
      }

      if (input) {
        input.placeholder = 'Frag mich zu Zunftbild.de …';
        input.maxLength = 400;
      }
      if (note) note.textContent = 'Schriftlicher Zunftmeister · durchsucht Zunftbild.de live.';
      if (firstBot) firstBot.textContent = 'Grüß dich! Frag mich zu Zünften, Handwerk, Berufen, Produkten oder anderen Inhalten auf Zunftbild.de.';

      const suggestions = ['Die Walz', 'Meisterstück', 'Dachdecker', 'Zunftzeichen', 'Rückgabe & Versand'];
      topicButtons.forEach((button, index) => {
        const label = suggestions[index];
        if (!label) return;
        button.textContent = label;
        button.dataset.zbSearchQuery = label;
        button.removeAttribute('data-url');
      });

      if (!form || !log || !input) return;

      const setStatus = (text, busy = false) => {
        if (!status) return;
        const dot = status.querySelector('span');
        Array.from(status.childNodes).forEach((node) => {
          if (node !== dot) node.remove();
        });
        status.appendChild(document.createTextNode(` ${text}`));
        status.dataset.busy = busy ? 'true' : 'false';
      };

      const appendMessage = (role, text) => {
        const message = document.createElement('div');
        message.className = `zb-zm__message zb-zm__message--${role}`;
        message.textContent = text;
        log.appendChild(message);
        log.scrollTop = log.scrollHeight;
        return message;
      };

      const appendResultMessage = (results) => {
        const message = document.createElement('div');
        message.className = 'zb-zm__message zb-zm__message--bot zb-zm__message--results';

        const intro = document.createElement('p');
        intro.className = 'zb-zm__answer-copy';
        intro.textContent = results.length === 1
          ? 'Dazu habe ich auf Zunftbild.de einen passenden Inhalt gefunden:'
          : 'Dazu habe ich auf Zunftbild.de diese passenden Inhalte gefunden:';
        message.appendChild(intro);

        const list = document.createElement('div');
        list.className = 'zb-zm__source-list';

        results.slice(0, 3).forEach((result) => {
          const card = document.createElement('div');
          card.className = 'zb-zm__source';

          const meta = document.createElement('span');
          meta.className = 'zb-zm__source-type';
          meta.textContent = typeLabel(result.type);
          card.appendChild(meta);

          const link = document.createElement('a');
          link.className = 'zb-zm__source-link';
          link.href = preservePreview(result.url || '/');
          link.textContent = result.title || 'Passenden Inhalt öffnen';
          card.appendChild(link);

          if (result.snippet) {
            const snippet = document.createElement('p');
            snippet.className = 'zb-zm__source-snippet';
            snippet.textContent = result.snippet;
            card.appendChild(snippet);
          }

          list.appendChild(card);
        });

        message.appendChild(list);
        log.appendChild(message);
        log.scrollTop = log.scrollHeight;
      };

      const buildEndpoint = (query) => {
        const rootPath = window.Shopify?.routes?.root || '/';
        const url = new URL(`${rootPath}search/suggest.json`, window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product,page,article,collection');
        url.searchParams.set('resources[limit]', '8');
        url.searchParams.set('resources[options][unavailable_products]', 'hide');
        url.searchParams.set('resources[options][fields]', 'title,body,product_type,variants.title,vendor');
        return url;
      };

      const flattenResults = (payload) => {
        const groups = payload?.resources?.results || {};
        const ordered = [
          ['pages', 'page'],
          ['articles', 'article'],
          ['products', 'product'],
          ['collections', 'collection']
        ];
        const seen = new Set();
        const items = [];

        ordered.forEach(([key, type]) => {
          (Array.isArray(groups[key]) ? groups[key] : []).forEach((item) => {
            const url = item?.url || '';
            const identity = `${type}:${url || item?.title || ''}`;
            if (!url || seen.has(identity)) return;
            seen.add(identity);
            items.push({
              type,
              title: stripHtml(item?.title || ''),
              url,
              body: stripHtml(item?.body || item?.description || ''),
              raw: item
            });
          });
        });
        return items;
      };

      const searchOnce = async (query, signal) => {
        const response = await fetch(buildEndpoint(query), {
          method: 'GET',
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          signal
        });
        if (!response.ok) throw new Error(`predictive-search-${response.status}`);
        return flattenResults(await response.json());
      };

      const mergeUnique = (groups) => {
        const seen = new Set();
        const merged = [];
        groups.flat().forEach((item) => {
          const key = `${item.type}:${item.url}`;
          if (seen.has(key)) return;
          seen.add(key);
          merged.push(item);
        });
        return merged;
      };

      const hydrateBody = async (result, signal) => {
        if (result.body && result.body.length >= 120) return result;
        if (!result.url || result.type === 'collection') return result;

        const cacheKey = result.url;
        if (cache.has(cacheKey)) return { ...result, body: cache.get(cacheKey) };

        try {
          const response = await fetch(preservePreview(result.url), {
            method: 'GET',
            headers: { Accept: 'text/html' },
            credentials: 'same-origin',
            signal
          });
          if (!response.ok) return result;
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('script,style,noscript,svg,nav,header,footer,form').forEach((node) => node.remove());
          const main = doc.querySelector('main') || doc.body;
          const text = (main?.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 16000);
          if (text) cache.set(cacheKey, text);
          return { ...result, body: text || result.body };
        } catch (error) {
          if (error?.name === 'AbortError') throw error;
          return result;
        }
      };

      const scoreResult = (result, question, keywords) => {
        const haystack = normalize(`${result.title} ${result.body}`);
        let score = result.type === 'page' ? 8 : result.type === 'article' ? 7 : result.type === 'product' ? 5 : 3;
        const questionNorm = normalize(question);
        const productIntent = /(kauf|produkt|bild|geschenk|preis|a3|a4|rahmen|bestell)/.test(questionNorm);
        if (productIntent && result.type === 'product') score += 7;
        keywords.forEach((keyword) => {
          const token = normalize(keyword);
          if (normalize(result.title).includes(token)) score += 7;
          if (haystack.includes(token)) score += 2;
        });
        return score;
      };

      const makeSnippet = (text, keywords) => {
        const clean = String(text || '').replace(/\s+/g, ' ').trim();
        if (!clean) return '';
        const sentences = clean.match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [clean];
        const ranked = sentences
          .map((sentence, index) => {
            const normalizedSentence = normalize(sentence);
            const hits = keywords.reduce((sum, keyword) => sum + (normalizedSentence.includes(normalize(keyword)) ? 1 : 0), 0);
            return { sentence: sentence.trim(), index, hits };
          })
          .sort((a, b) => b.hits - a.hits || a.index - b.index);
        const best = ranked[0]?.sentence || clean;
        const snippet = best.length < 100 && ranked[1]?.sentence ? `${best} ${ranked[1].sentence}` : best;
        return snippet.length > 320 ? `${snippet.slice(0, 317).trim()}…` : snippet;
      };

      const answerQuestion = async (question) => {
        const serial = ++requestSerial;
        if (activeController) activeController.abort();
        activeController = new AbortController();
        const signal = activeController.signal;
        const keywords = extractKeywords(question);
        const searchQuery = keywords.length ? keywords.join(' ') : question;

        setStatus('Durchsuche Zunftbild.de …', true);

        try {
          let results = await searchOnce(searchQuery, signal);
          if (results.length < 3 && keywords.length > 1) {
            const fallbackQueries = keywords.slice(0, 2);
            const fallbacks = await Promise.all(fallbackQueries.map((keyword) => searchOnce(keyword, signal)));
            results = mergeUnique([results, ...fallbacks]);
          }

          if (serial !== requestSerial) return;
          if (!results.length) {
            appendMessage('bot', 'Dazu finde ich auf Zunftbild.de gerade keinen passenden öffentlichen Inhalt. Versuch es mit einem Beruf, einer Zunft, einem Werkzeug, einer Stadt, einer Tradition oder einem Produktnamen.');
            setStatus('Keine passende Seite gefunden');
            return;
          }

          const candidates = results
            .sort((a, b) => scoreResult(b, question, keywords) - scoreResult(a, question, keywords))
            .slice(0, 5);

          const hydrated = await Promise.all(candidates.slice(0, 3).map((item) => hydrateBody(item, signal)));
          if (serial !== requestSerial) return;

          const finalResults = hydrated
            .map((item) => ({ ...item, snippet: makeSnippet(item.body, keywords) }))
            .sort((a, b) => scoreResult(b, question, keywords) - scoreResult(a, question, keywords));

          appendResultMessage(finalResults);
          setStatus(`${results.length} passende Inhalte gefunden`);
        } catch (error) {
          if (error?.name === 'AbortError') return;
          appendMessage('bot', 'Die Website-Suche war gerade nicht erreichbar. Versuch deine Frage bitte noch einmal.');
          setStatus('Suche vorübergehend nicht erreichbar');
        }
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest?.('[data-zb-zm-topic]');
        if (!button || !root.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        const query = button.dataset.zbSearchQuery || button.textContent.trim();
        appendMessage('user', query);
        answerQuestion(query);
      }, true);

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const question = input.value.trim();
        if (!question) return;
        appendMessage('user', question);
        input.value = '';
        answerQuestion(question);
      }, true);

      window.addEventListener('pagehide', () => {
        if (activeController) activeController.abort();
      }, { once: true });

      setStatus('Bereit für deine Frage');
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["zunftmeister-widget"] && !Shopify.designMode) return;
  try {
    (() => {
  const STORAGE_KEY = 'zb-zunftmeister-arrival-v1';

  const init = () => {
    document.querySelectorAll('[data-zb-zm]').forEach((root) => {
      if (root.dataset.zbReady === 'true') return;
      root.dataset.zbReady = 'true';

      const toggle = root.querySelector('[data-zb-zm-toggle]');
      const panel = root.querySelector('[data-zb-zm-panel]');
      const close = root.querySelector('[data-zb-zm-close]');
      const log = root.querySelector('[data-zb-zm-log]');
      const form = root.querySelector('[data-zb-zm-form]');
      const input = root.querySelector('[data-zb-zm-input]');
      const topicButtons = [...root.querySelectorAll('[data-zb-zm-topic]')];

      if (!toggle || !panel || !close || !log || !form || !input) return;

      const appendMessage = (role, text) => {
        const message = document.createElement('div');
        message.className = `zb-zm__message zb-zm__message--${role}`;
        message.textContent = text;
        log.appendChild(message);
        log.scrollTop = log.scrollHeight;
      };

      const openPanel = (focusInput = false) => {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        if (focusInput) window.setTimeout(() => input.focus(), 50);
      };

      const closePanel = () => {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      };

      const preservePreview = (href) => {
        try {
          const target = new URL(href, window.location.origin);
          const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
          if (previewId) target.searchParams.set('preview_theme_id', previewId);
          return target.pathname + target.search + target.hash;
        } catch (error) {
          return href;
        }
      };

      const storeArrival = (label, href) => {
        try {
          const target = new URL(href, window.location.origin);
          sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ label, path: target.pathname, at: Date.now() }));
        } catch (error) {
          /* Navigation still works when sessionStorage is unavailable. */
        }
      };

      const goToTopic = (label, href, echoUser = true) => {
        if (!href) return;
        if (echoUser) appendMessage('user', label);
        appendMessage('bot', `Gern. Ich öffne dir jetzt „${label}“ im Zunftlexikon.`);
        const target = preservePreview(href);
        storeArrival(label, target);
        window.setTimeout(() => window.location.assign(target), 650);
      };

      const normalized = (value) => value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

      const findTopic = (question) => {
        const text = normalized(question);
        const byLabel = (needle) => topicButtons.find((button) => normalized(button.dataset.label || '').includes(needle));

        if (text.includes('walz') || text.includes('wandergesell')) return byLabel('walz');
        if (text.includes('meisterstuck') || text.includes('meister werden') || text.includes('meisterpruf')) return byLabel('meisterstuck');
        if (text.includes('freisprech')) return byLabel('freisprech');
        if (text.includes('lehrling') || text.includes('ausbildung') || text.includes('gesellenwesen')) return byLabel('ausbildung');
        if (text.includes('beruhm') || text.includes('meisterwerk')) return byLabel('beruhmte');
        return null;
      };

      toggle.addEventListener('click', () => {
        if (panel.hidden) openPanel(true);
        else closePanel();
      });

      close.addEventListener('click', closePanel);

      topicButtons.forEach((button) => {
        button.addEventListener('click', () => goToTopic(button.dataset.label || button.textContent.trim(), button.dataset.url));
      });


      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const question = input.value.trim();
        if (!question) return;

        appendMessage('user', question);
        input.value = '';
        const topic = findTopic(question);

        if (topic) {
          goToTopic(topic.dataset.label || topic.textContent.trim(), topic.dataset.url, false);
          return;
        }

        appendMessage('bot', 'Ich helfe dir, passende Lexikonseiten zu finden. Wähle ein Thema wie Walz, Meisterstück, Freisprechung, Ausbildung oder berühmte Handwerker.');
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !panel.hidden) closePanel();
      });

      try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (raw) {
          const arrival = JSON.parse(raw);
          const fresh = !arrival.at || Date.now() - arrival.at < 120000;
          if (fresh && arrival.path === window.location.pathname) {
            sessionStorage.removeItem(STORAGE_KEY);
            openPanel(false);
            appendMessage('bot', `Hier ist die passende Seite zu „${arrival.label}“. Viel Freude beim Entdecken der Handwerksgeschichte.`);
          } else if (!fresh) {
            sessionStorage.removeItem(STORAGE_KEY);
          }
        }
      } catch (error) {
        /* Ignore malformed or blocked sessionStorage. */
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
